import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTranexamicAcidGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m24.03 17.12-2.03.3.78 5.09-1.22.19-.78-5.09-2.03.31-.17-1.14 5.28-.8.17 1.14ZM30.25 21.37l-1.33.2-.73-1.3-2.48.38-.31 1.46-1.33.2 1.46-6.6 1.34-.2 3.38 5.86Zm-3.87-3.9-.44 2.06 1.71-.26-1.04-1.84-.17-.33-.06.37Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M8 23.02 17 10l15.8 1.05 6.9 14.48-8.95 13.15-15.94-1.23L8 23.02Zm7.66 13.26 14.52 1.12 8.15-11.98-6.28-13.18-14.39-.96-8.2 11.86 6.2 13.14Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m16.21 30.11-2.7-6.3 6.96 1.16-4.26 5.14Zm-.65-4.69.99 2.32 1.57-1.89-2.56-.43ZM27.69 34.05 22.4 27.6l8.53-1-3.24 7.45Zm-2.88-5.47 2.54 3.1 1.56-3.58-4.1.48Z",
    fill: "currentColor"
  }));
}

export { SvgTranexamicAcidGlyph as default };
